import { createFileRoute } from "@tanstack/react-router";

import { ApiKeyCard } from "../../components/home/ApiKeyCard";
import { GettingStartedSection } from "../../components/home/GettingStartedSection";
import { SupportedModelsSection } from "../../components/home/SupportedModelsSection";

export const Route = createFileRoute("/_authed/")({
  component: HomePage,
  head: () => ({
    meta: [{ title: "Nubank Developer Console" }],
  }),
});

function HomePage() {
  return (
    <div className="flex flex-col gap-8">
      <ApiKeyCard />
      <GettingStartedSection />
      <SupportedModelsSection />
    </div>
  );
}
